// src/services/orderReturnService.js
import axios from 'axios';
import { toFormData } from './utils'; // Utility function
import { setAuthToken } from './setAuthToken';

const orderReturnService = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
});

// Assuming you have a token from somewhere (e.g., after login)
const token = localStorage.getItem('token') || sessionStorage.getItem('token');
setAuthToken(orderReturnService, token);

export const createReturnOrderService = (orderData) => {
    const formData = toFormData(orderData);
    return orderReturnService.post('/order-return/create', formData);
};

export const getReturnOrdersService = (paramData) => {
    const formData = toFormData(paramData);
    return orderReturnService.post('/order-return/list', formData);
};

export const getReasonOfReturnOptions = () => {
    return orderReturnService.get('/order-return/reason-of-return-options');
};

export const getStoreAddresses = () => {
    return orderReturnService.get('/order-return/store-addresses');
};

